import React from 'react'
import { helper } from '../utilities/helper'
import PicCont from './PicCont'
import { useSelector } from 'react-redux'
import { getMedia } from '../store/slices/user'


const StageRender = ({rows, cols, type, additions, showAds, setAdditions, height, stepsNum}) => {
    let {mobile, laptop, tablet} = useSelector(getMedia)

   let mediaDim = (mobile ? 0.4 : tablet ? 0.65 : laptop? 0.85 :1) - (type === 'lumo' ? 0.1 : type === 'msr'  ? mobile ? 0.2 : 0.4 : 0)

   let mod = type === 'lumo' ? 0.13 - (( (cols * 0.004) + (rows * 0.003) ) ) : ((rows >=13  || cols >= 13 )? 0.04 :   (rows >=9  || cols >= 9 )? 0.05 :  rows * cols >= 9 ? 0.062 : 0.07)

   // Invalid persisted dimensions must not crash the entire order review.
   if (!Number.isInteger(rows) || rows < 0 || rows > 4294967295 ||
       !Number.isFinite(cols) || cols < 0 || Math.round(cols) > 4294967295) {
     return <span className='stageRenderUnavailable'>Preview unavailable</span>
   }

  return <div className={`stageRender ${type} ${type === 'lumo' && height === '16' ? 'bigLumo' : ''}`}>
    {stepsNum >0 && <div className='steps'>
        <PicCont height={600} width={600} picture={type === 'msr' ? 'myImage-1715616990836.jpg' : 'myImage-1674160492815.jpg'} />
        <div className="counter">{stepsNum}</div>
      </div>}
    <div className={`stageCont`} style={{transform: `scale(${mediaDim-(((cols*(type=== 'lumo' ? 0.95:type=== 'msr' ? 1.2: 1))+(rows*(type=== 'lumo' ? 0.5: 1)))*mod*mediaDim)})`, marginLeft: `${(rows*mediaDim)*50}px`}} >
    {helper.makeSeries(rows).map(r => <div key={`r${r}`} className='stageRow' style={{marginLeft: `-${r*(type === 'msr' ? 230 :type === 'lumo' ? 230 :  200)}px`}}>
        {helper.makeSeries(Math.round(cols)).map(c => <div key={`c${r}${c}`} className='stageCol'  >
            <PicCont width={type ==='lumo' ? 600 : type === 'msr' ? 800 : 400} height={type ==='lumo' ? 400 :600} picture={type === 'lumo' ? additions?.lights ? `lumo${height === '16' ? '16' : ''}l.png` : `lumo${height === '16' ? '16' : ''}m.png` : `${type}-${r=== rows && additions.Skirt?.front? 's' : 'n'}${c=== cols && additions.Skirt?.right? 's' : 'n'}-${c=== 1 && additions.Railing?.left? 's' : 'n'}${r=== 1 && additions.Railing?.rear? 's' : 'n'}${c=== cols && additions.Railing?.right? 's' : 'n'}.png`} />
        </div>)}
    </div>)}
    </div>


  </div>
}

export default StageRender